import React, { useEffect, useCallback, useState} from 'react';
import {trim} from "utils/trim.js";
import EffectPresets from './EffectPresets.js';
import {addEffect} from 'scripting/commands/effects.js';
import {connect} from 'react-redux';

const EffectChoice = ({isSelected, effect, sequencerEngine, matchedPresets}) => { 
    const [isCollapsed, setIsCollapsed] = useState(matchedPresets.length === 0);
    return (
        <div
          className={isSelected ? "effect-option selected" : "effect-option"}>
          <div
            className="inner">
            <div
              onClick={(e) => {
                  e.stopPropagation();
                  setIsCollapsed(!isCollapsed);
              }}
              className="collapse-toggle">
              <div className={isCollapsed ? "arrow-right" : "arrow-down"}/>
            </div>
            <div
              onClick={() => addEffect(sequencerEngine, effect)}
              className="effect-name">
              {trim(effect)}
            </div>
          </div>
          {!isCollapsed ? <EffectPresets
                            matchedPresets={matchedPresets}
                            sequencerEngine={sequencerEngine} effect={effect}/> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectChoice);
